import React from "react";
import { DeleteIcon, EditIcon } from "assests/GmsIcons";
import { CBM, CONDITIONAL, DBM } from "../../ISRConstants";

export type propTypeDoc = {
  id?: any;
  ruleName?: string;
  description?: string;
  ruleExp?: string;
  onClickHandler:Function;
  ruleType:string|undefined|null;
};

/* One outline icon-button recipe for both actions, size-matched to the legacy
   h-7 px-2.5 geometry. `icon-follow-ink` re-inks DeleteIcon's hardcoded
   #747593 strokes to the button's ink (EditIcon already draws currentColor). */
const ACTION_BTN =
  "tw-m-1 tw-rounded tw-bg-surface tw-text-accent icon-follow-ink tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm tw-border tw-border-solid tw-border-accent hover:tw-bg-accent-tint";

const RulesCard = (props: React.PropsWithChildren<propTypeDoc>) => {
  return (
    <div className=" tw-bg-surface-sunken tw-rounded tw-border tw-border-edge tw-mt-5 tw-m-1">
      <div className="tw-flex tw-justify-between tw-items-center ">
        <label className="tw-w-[443px] tw-text-ink tw-text-sm  tw-leading-tight tw-ml-3">
          {props.ruleName}
        </label>
        <div className="tw-flex tw-justify-between tw-items-center">
        <button aria-label="Edit" data-testid="rules-rulescard-button-1"
          className={ACTION_BTN}
          onClick={(e) => {props.onClickHandler(props.id, "edit", props.ruleType)}}
        >
          <EditIcon />
        </button>
        <button aria-label="Delete" data-testid="rules-rulescard-button-2"
          className={ACTION_BTN}
          onClick={(e) => {props.onClickHandler(props.id, "delete")}}
        >
          <DeleteIcon />
        </button>

        </div>

      </div>
      <div className="tw-w-[443px] tw-text-ink-secondary tw-text-sm font-normal tw-font-['Noto Sans'] tw-leading-tight tw-ml-3 tw-mb-1">
        {props.description}
      </div>
      <label className="tw-w-[443px] tw-text-ink tw-text-sm  tw-leading-tight tw-ml-3">
          Rule Type: {props.ruleType}
        </label>
      {props?.ruleType !== CBM && props?.ruleType !== CONDITIONAL && props?.ruleType !== DBM &&<div className=" tw-bg-surface tw-text-ink tw-rounded tw-border tw-border-edge tw-m-3 tw-break-words tw-p-1">
        {props.ruleExp}
      </div>}
    </div>
  );
};

export default RulesCard;
